// extracted by mini-css-extract-plugin
export default {"root":"FamilyPage__root--Jni8e","content":"FamilyPage__content--1ynKX","title":"FamilyPage__title--9Aq72"};